/**
 * @generated SignedSource<<175c8fa456f072bc67e0102f8899c9e0>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type UserNotificationPayloadEnum = "ACTIVITY_FEED" | "ITEM_EVENT" | "MESSAGE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type useGetAllUnreadNotifications_userNotifications$data = {
  readonly earlier: {
    readonly all: ReadonlyArray<{
      readonly notificationType: UserNotificationPayloadEnum | null;
      readonly payload: {
        readonly serviceId?: string | null;
        readonly unreadTag?: {
          readonly serviceId: string | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
  readonly latest: {
    readonly all: ReadonlyArray<{
      readonly notificationType: UserNotificationPayloadEnum | null;
      readonly payload: {
        readonly serviceId?: string | null;
        readonly unreadTag?: {
          readonly serviceId: string | null;
        } | null;
      } | null;
    } | null> | null;
    readonly messages: ReadonlyArray<{
      readonly serviceId: string | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "useGetAllUnreadNotifications_userNotifications";
};
export type useGetAllUnreadNotifications_userNotifications$key = {
  readonly " $data"?: useGetAllUnreadNotifications_userNotifications$data;
  readonly " $fragmentSpreads": FragmentRefs<"useGetAllUnreadNotifications_userNotifications">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v1 = [
  (v0/*:: as any*/)
],
v2 = [
  (v0/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "UserNotificationsTag",
    "kind": "LinkedField",
    "name": "unreadTag",
    "plural": false,
    "selections": (v1/*:: as any*/),
    "storageKey": null
  }
],
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "UserNotification",
  "kind": "LinkedField",
  "name": "all",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notificationType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "payload",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": (v2/*:: as any*/),
          "type": "FavoriteNotification",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v2/*:: as any*/),
          "type": "ActivityFeedElement",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useGetAllUnreadNotifications_userNotifications",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UserNotificationsBucket",
      "kind": "LinkedField",
      "name": "latest",
      "plural": false,
      "selections": [
        (v3/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Conversation",
          "kind": "LinkedField",
          "name": "messages",
          "plural": true,
          "selections": (v1/*:: as any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserNotificationsBucket",
      "kind": "LinkedField",
      "name": "earlier",
      "plural": false,
      "selections": [
        (v3/*:: as any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "UserNotifications",
  "abstractKey": null
};
})();

(node as any).hash = "0f5188b5818aa557a2f18c93dd5b402e";

export default node;
